import React, { Component } from "react";
const { Provider, Consumer } = React.createContext();

class AppConfigProvider extends Component {
  state = {
    theme: "Day",
    hosturl: 'abc',
    branch: 'rty',
    mbouser: 'tbd'
  };

  toggleTheme = () => {
    this.setState(prevState => {
      return {
        theme: prevState.theme === "Day" ? "Night" : "Day"
      }
    })
  }

  render() {
    return (
      <Provider value={{ theme: this.state.theme, toggleTheme: this.toggleTheme }}>
        {this.props.children}
      </Provider>
    )
  }
}

export { AppConfigProvider, Consumer as AppConfigConsumer };
